import { render, staticRenderFns } from "./InputSelectColor.vue?vue&type=template&id=ba4b6994&scoped=true&"
import script from "./InputSelectColor.vue?vue&type=script&lang=js&"
export * from "./InputSelectColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4b6994",
  null
  
)

export default component.exports